/* GW PDP View Counter — <gw-view-counter>
   Rendered by snippets/gw-pdp-view-counter.liquid.

   Ported from the agency base theme's flow
   (/Users/ali/Developer/Shopify/Agency/golden/snippets/pdp-view-counter.liquid).
   The random walk, the bounds, and the Person/People + Is/Are agreement are
   that flow's, unchanged. What changed:
     - it was a bare inline <script>, which re-runs per instance in this theme;
     - its document.querySelector('.pdp-view-counter') only ever found the
       FIRST counter on the page, so a second block would never update;
     - it hardcoded a 60000ms interval that ignored its own update_interval
       setting. Here the setting is honoured.

   The interval is cleared on disconnect — a PDP section re-renders on every
   variant change in the theme editor, and an uncleared timer would stack. */

if (!customElements.get('gw-view-counter')) {
  customElements.define(
    'gw-view-counter',
    class GwViewCounter extends HTMLElement {
      connectedCallback() {
        this.numberEl = this.querySelector('.gw-pdp-view-counter__number');
        this.labelEl = this.querySelector('.gw-pdp-view-counter__label');
        this.verbEl = this.querySelector('.gw-pdp-view-counter__verb');

        if (!this.numberEl) return;

        this.maxNumber = parseInt(this.dataset.maxNumber, 10) || 10;

        const seconds = parseInt(this.dataset.updateInterval, 10);
        this.intervalMs = (Number.isFinite(seconds) && seconds > 0 ? seconds : 30) * 1000;

        this.setCount(this.randomBetween(1, this.maxNumber));
        this.timer = setInterval(() => this.step(), this.intervalMs);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      randomBetween(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

      setCount(n) {
        this.numberEl.textContent = n;

        if (!this.labelEl || !this.verbEl) return;

        this.labelEl.textContent = n === 1 ? 'Person' : 'People';
        this.verbEl.textContent = n === 1 ? 'Is' : 'Are';
      }

      /* A weighted walk rather than a fresh random each tick: 40% drift up,
         30% drift down, 30% jump. Straight from the base theme. */
      step() {
        const current = parseInt(this.numberEl.textContent, 10) || 1;
        const change = Math.random();
        let next;

        if (change < 0.4 && current < this.maxNumber) {
          next = Math.min(current + this.randomBetween(1, 3), this.maxNumber);
        } else if (change < 0.7 && current > 1) {
          next = Math.max(current - this.randomBetween(1, 2), 1);
        } else {
          next = this.randomBetween(1, this.maxNumber);
        }

        this.setCount(next);
      }
    }
  );
}
